import { render, staticRenderFns } from "./LinkAccountFormComponent.vue?vue&type=template&id=10936e5c&scoped=true&"
import script from "./LinkAccountFormComponent.vue?vue&type=script&lang=ts&"
export * from "./LinkAccountFormComponent.vue?vue&type=script&lang=ts&"
import style0 from "./LinkAccountFormComponent.vue?vue&type=style&index=0&id=10936e5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10936e5c",
  null
  
)

export default component.exports